module.exports = __webpack_public_path__ + "static/media/showroomNew.d279ccaa.svg";